import React from 'react'
import { Outlet } from 'react-router-dom'

const QuizManagement = () => {
  return (
    <>
     <Outlet/> 
    </>
  )
}

export default QuizManagement
